import {newsfeedService} from "./newsfeed-service";

let slider = null;
let slides = null;
let buttonLeft = null;
let buttonRight = null;
let activeSlide = 1;
let observer = null


document.addEventListener("DOMContentLoaded", () => {
    const sliderWrapper = document.querySelector(".employee-stories");

    if (sliderWrapper) {
        slider = sliderWrapper.querySelector(".stories");
        slides = slider.querySelectorAll(".story-wrapper");
        buttonLeft = sliderWrapper.querySelector(".buttons .left");
        buttonRight = sliderWrapper.querySelector(".buttons .right");

        if (slides.item(1)) {
            slider.scrollTo(slider.scrollLeft + slides.item(1).getBoundingClientRect().width, 0)
        }

        if (slides.length < 4) {
            buttonRight.classList.add("disabled");
        }

        buttonRight.addEventListener("click", () => {
            const next = slides.item(activeSlide + 2);

            if (next) {
                slider.scrollTo(slider.scrollLeft + next.getBoundingClientRect().width, 0)
                activeSlide++;
            }

            if (buttonLeft.classList.contains("disabled")) {
                buttonLeft.classList.remove("disabled");
            }

            if (!slides.item(activeSlide + 2) && !buttonRight.classList.contains("disabled")) {
                buttonRight.classList.add("disabled");
            }
        })

        buttonLeft.addEventListener("click", () => {
            const prev = slides.item(activeSlide - 2);

            if (prev) {
                slider.scrollTo(slider.scrollLeft - prev.getBoundingClientRect().width, 0)
                activeSlide--;
            }

            if (buttonRight.classList.contains("disabled")) {
                buttonRight.classList.remove("disabled");
            }

            if (!slides.item(activeSlide - 2) && !buttonLeft.classList.contains("disabled")) {
                buttonLeft.classList.add("disabled");
            }
        })

        observer = new IntersectionObserver((callback) => {
            callback.forEach(item => {
                if (item.isIntersecting) {
                    for (let i = 0; i < slides.length; i++) {
                        if (slides[i] === item.target) {
                            if (i === slides.length - 2) {
                                newsfeedService.loadStories().then(() => {
                                    syncSliderVars()
                                })
                            }
                        }
                    }
                }
            })
        }, {
            root: slider,
            rootMargin: '0px',
            threshold: 1
        });

        slides.forEach(slide => {
            observer.observe(slide)
        })
    }
})

export const syncSliderVars = () => {
    const sliderWrapper = document.querySelector(".employee-stories");
    slider = sliderWrapper.querySelector(".stories");
    slides = slider.querySelectorAll(".story-wrapper");
    buttonLeft = sliderWrapper.querySelector(".buttons .left");
    buttonRight = sliderWrapper.querySelector(".buttons .right");

    if (slides.item(activeSlide + 2) && buttonRight.classList.contains("disabled")) {
        buttonRight.classList.remove("disabled");
    }

    slides.forEach(slide => {
        observer.observe(slide)
    })
}
